import React, { Fragment, useEffect, useState } from 'react'
import Loading from '../assetLibComponents/Loading'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { saveNotificationPriority, fetchNotificationCheckList, saveIntelNotification, getNotificationData } from '../../redux/actions/settingActions';
import { Combobox, Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'react-tooltip';
import { HiOutlineInformationCircle } from 'react-icons/hi';

const timeSlots =  [
    { id: 1, time: "07:00 AM" },
    { id: 2, time: "08:00 AM" },
    { id: 3, time: "09:00 AM" },
    { id: 4, time: "10:00 AM" },
    { id: 5, time: "11:00 AM" },
    { id: 6, time: "12:00 PM" },
    { id: 7, time: "01:00 PM" },
    { id: 8, time: "02:00 PM" },
    { id: 9, time: "03:00 PM" },
    { id: 10, time: "04:00 PM" },
    { id: 11, time: "05:00 PM" },
    { id: 12, time: "06:00 PM" },
    { id: 13, time: "07:00 PM" },
]

const dayNameData = [
    { id: 1, day: "Sunday" },
    { id: 2, day: "Monday" },
    { id: 3, day: "Tuesday" },
    { id: 4, day: "Wednesday" },
    { id: 5, day: "Thursday" },
    { id: 6, day: "Friday" },
    { id: 7, day: "Saturday" },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const SettingNotification = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.setting.loading);
  const [query, setQuery] = useState('')
  const notification_check = useSelector((state) => state.setting.notification_check);
  const notification_Data = useSelector((state) => state.setting.notificationData?.detail);
  const [notificationData, setNotificationData] = useState(false);
  const [toggle, setToggle] = useState("Intel");
  const [compWeek, setCompWeek] = useState(false);
  const [compDay, setCompDay] = useState(false);
  const [industryDay, setIndustryDay] = useState(false);
  const [industryWeek, setIndustryWeek] = useState(false);
  const [companyDay, setCompanyDay] = useState(false);
  const [companyWeek, setCompanyWeek] = useState(false);
  const [dailyTime, setDailyTime] = useState()
  const [weekTime, setWeekTime] = useState()

  console.log(notification_Data?.time_slots,"notification_Data")

  
  const filteredSlots =
    query === ''
      ? timeSlots
      : timeSlots.filter((timeValue) => {
          return timeValue.time.toLowerCase().includes(query.toLowerCase())
      })
  
  const filteredDaySlots =
    query === ''
      ? dayNameData
      : dayNameData.filter((dayNewValue) => {
          return dayNewValue.day.toLowerCase().includes(query.toLowerCase())
      })
  
  useEffect(() => {
    dispatch(fetchNotificationCheckList(props.authToken, ""));
    dispatch(getNotificationData(props.authToken));
    if(notification_Data){
      setCompWeek(notification_Data?.competence_categories?.weekly)
      setCompDay(notification_Data?.competence_categories?.daily)
      setIndustryDay(notification_Data?.industry?.daily)
      setIndustryWeek(notification_Data?.industry?.weekly)
      setCompanyDay(notification_Data?.company?.daily)
      setCompanyWeek(notification_Data?.company?.weekly)
      setDailyTime(notification_Data?.daily_time)
      setWeekTime(notification_Data?.weekly_time)
    }
  }, []);
  
  useEffect(() => {
    if (notification_check?.length > 0) {
      let temp_data = [...notification_check]
      let timeValueNew, dayValueNew;
      temp_data.map((data, index) => {
        if (index === 0) {
          data.heading = "Stay Informed in Real Time";
          data.sub_heading = "Get immediate notification for new leads.";
          data.tooltip = "";
          data.send_time = null;
          data.send_day = null;
        } else if (index === 1) {
          data.heading = "Daily Leads Notification";
          data.sub_heading = "Get daily notification for new leads.";
          timeValueNew = timeSlots.filter((time) => time.time == data.send_time);
          data.tooltip = "This setting only lets you choose when you receive the daily report, not when this report is generated. Daily reports are generated at 5 am every day and cover the activity of the previous 24 hours.";
          data.send_time = timeValueNew[0];
          data.send_day = null;
        } else {
          data.heading = "Weekly Leads Update";
          data.sub_heading = "Get weekly notification for new leads.";
          timeValueNew = timeSlots.filter((time) => time.time == data.send_time);
          data.send_time = timeValueNew[0]
          data.tooltip = "This setting only lets you choose when you receive the weekly report, not when this report is generated. Weekly reports are generated at 5 am every Monday and cover the activity of the previous 7 days.";
          dayValueNew = dayNameData.filter((day) => day.id == data.send_day);
          data.send_day = dayValueNew[0];
        }
        return data;
      })
      setNotificationData(temp_data);
    }
  }, [notification_check])
  
  const handleslotChange = (e, num, type) => {
    let arrayData = [...notificationData];
    arrayData.map((data, ind) => {
      if (ind === num && type === "time") {
        data.send_time = e;
      }
      if (ind === num && type === "day") {
        data.send_day = e;
      }
    })
    setNotificationData(arrayData);
  }

  const handleSubmit = (e) => {
    if(toggle == "Intel"){
      // console.log("ih")
      let payload={
        "industry":{"daily":industryDay,"weekly":industryWeek},
        "company":{"daily":companyDay,"weekly":companyWeek},
        "competence_categories":{"daily":compDay,"weekly":compWeek},
      }
      dispatch(saveIntelNotification(props.authToken, payload,dailyTime?.time_slot,weekTime?.time_slot));
    }else{
      let payload = [...notificationData];
      payload.map((item, index) => {
        item.send_time = item?.send_time?.time || null;
        item.send_day = item?.send_day?.id || null;
      })
      dispatch(saveNotificationPriority(props.authToken, payload));
    }
  }


  return (
     <>
      {isLoading && <Loading />}
        <>
        <div className="px-0">
          <div className="flex mb-2 border-b border-gray-200 ">
            <div className={`text-lg leading-7 font-[500] my-auto mr-5 pb-3 cursor-pointer  ${toggle == "Intel" && "border-b-2 border-solid border-[var(--brand-primary)]" }`} onClick={()=>{setToggle("Intel")}}>Intel</div>  
            <div className={`text-lg leading-7 font-[500] my-auto cursor-pointer  pb-3 ${toggle == "Chatbot" && "border-b-2 border-solid border-[var(--brand-primary)]" }`} onClick={()=>{setToggle("Chatbot")}}>Chatbot</div>  
            <button
              type="button"
              className="mr-4 mb-2 ml-auto my-auto inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{handleSubmit();}}
            >
            Save Changes
          </button>            
          </div>
          {toggle == "Chatbot" && 
          <div className="mt-6 max-sm:mt-4 flow-root w-1/2 max-sm:w-full">
            <div>
                <fieldset>
                  <legend className="sr-only">Notifications</legend>
                  <div className="space-y-5">
                  {notificationData.length > 0 && notificationData.map((noti, n_index) => {
                    return (
                      <div>
                        <div className="relative flex items-start">
                          <div className="flex h-6 items-center">
                            <input
                              name="notification"
                              type="checkbox"
                              checked={noti.status == 0 ? false : true}
                              onChange={(e) => {
                                let arrayData = [...notificationData];
                                arrayData.map((item, index) => {
                                  if (index == n_index) {
                                    item.status = e.target.checked === true ? 1 : 0;
                                  }
                                })
                                setNotificationData(arrayData);
                              }}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label htmlFor="weekly" className="font-medium gap-2 flex items-center text-gray-900">
                              {noti.heading} {noti.tooltip !== "" && <a data-tooltip-id="my-tooltip" data-tooltip-content={noti?.tooltip}><HiOutlineInformationCircle className="text-gray-900 text-[1rem] my-auto"></HiOutlineInformationCircle></a>}
                            </label>
                            <p id="weekly-description" className="text-gray-500">
                              {noti.sub_heading}
                            </p>
                          </div>
                        </div>
                        {(noti.status == "1" && n_index !== 0) && <div className='mt-4 pl-6'>
                          <div className="flex mb-2 max-sm:gap-2 gap-6">
                            {/* set hours time dropdown */}
                            <Listbox
                              value={noti?.send_time}
                              onChange={(e) => {
                                handleslotChange(e, n_index, "time");
                              }}
                            >
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button className="relative w-[140px] cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                      <span className="block truncate text-gray-700">{noti?.send_time?.time || "Select time.."}</span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      {filteredSlots?.length > 0 && (
                                        <Listbox.Options className="absolute z-10 listing mt-1 max-h-36 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {filteredSlots?.map((timeValue) => (
                                            <Listbox.Option
                                              key={timeValue?.id}
                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                                )
                                              }
                                              value={timeValue}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {timeValue?.time}
                                                  </span>

                                                  {selected ? (
                                                    <span
                                                      className={classNames(
                                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                      )}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))}
                                        </Listbox.Options>
                                      )}
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                            {/* set days dropdown */}
                            {n_index === 2 && <>
                            <Listbox
                              value={noti?.send_day}
                              onChange={(e) => {
                                handleslotChange(e, n_index, "day");
                              }}
                            >
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button className="relative w-[140px] cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                      <span className="block truncate text-gray-700">{noti?.send_day?.day || "Select day.."}</span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      {filteredDaySlots?.length > 0 && (
                                        <Listbox.Options className="absolute z-10 listing mt-1 max-h-36 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {filteredDaySlots?.map((dayValue) => (
                                            <Listbox.Option
                                              key={dayValue.id}
                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                                )
                                              }
                                              value={dayValue}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {dayValue.day}
                                                  </span>

                                                  {selected ? (
                                                    <span
                                                      className={classNames(
                                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                      )}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))}
                                        </Listbox.Options>
                                      )}
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                            </>}
                          </div>
                        </div>}
                    </div>
                    );
                  })}
                  </div>
                </fieldset>
            </div>
          </div>}
          {toggle == "Intel" && 
          <div className="mt-6 max-sm:mt-4 flow-root w-1/2 max-sm:w-full">
            <div className='grid grid-cols-9 gap-9'>
            <div className='col-span-3 flex flex-col gap-y-8'>
                 <div className='mb-5'></div>
                 <div>Competence Category</div>
                 <div>Industry</div>
                 <div>Company</div>
                  </div>
                <div className='col-span-3 flex flex-col gap-y-9'>
                 <div className=''>Daily</div>
                 <input
                              name="notification"
                              type="checkbox"
                              checked={compDay}
                              onChange={(e)=>{setCompDay(e.target.checked)}}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                 <input
                              name="notification"
                              type="checkbox"
                              checked={industryDay}
                              onChange={(e)=>{setIndustryDay(e.target.checked)}}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                 <input
                              name="notification"
                              type="checkbox"
                              checked={companyDay}
                              onChange={(e)=>{setCompanyDay(e.target.checked)}}

                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                  </div>
                <div className='col-span-3 flex flex-col gap-y-9'>
                 <div className=''>Weekly</div>
                 <input
                              name="notification"
                              type="checkbox"
                              checked={compWeek}
                              onChange={(e)=>{setCompWeek(e.target.checked)}}
                              // checked={noti.status == 0 ? false : true}
                              // onChange={(e) => {
                              //   let arrayData = [...notificationData];
                              //   arrayData.map((item, index) => {
                              //     if (index == n_index) {
                              //       item.status = e.target.checked === true ? 1 : 0;
                              //     }
                              //   })
                              //   setNotificationData(arrayData);
                              // }}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                 <input
                              name="notification"
                              type="checkbox"
                              checked={industryWeek}
                              onChange={(e)=>{setIndustryWeek(e.target.checked)}}
                              // checked={noti.status == 0 ? false : true}
                              // onChange={(e) => {
                              //   let arrayData = [...notificationData];
                              //   arrayData.map((item, index) => {
                              //     if (index == n_index) {
                              //       item.status = e.target.checked === true ? 1 : 0;
                              //     }
                              //   })
                              //   setNotificationData(arrayData);
                              // }}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                 <input
                              name="notification"
                              type="checkbox"
                              checked={companyWeek}
                              onChange={(e)=>{setCompanyWeek(e.target.checked)}}
                              // checked={noti.status == 0 ? false : true}
                              // onChange={(e) => {
                              //   let arrayData = [...notificationData];
                              //   arrayData.map((item, index) => {
                              //     if (index == n_index) {
                              //       item.status = e.target.checked === true ? 1 : 0;
                              //     }
                              //   })
                              //   setNotificationData(arrayData);
                              // }}
                              className="h-4 w-4 ml-2 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                            /> 
                  </div>
            </div>

            <div className='flex gap-x-40 mt-14'>
              <div className='my-auto'>Daily Time</div>
            <div className="flex mb-2 max-sm:gap-2 gap-6 my-auto">
                            {/* set hours time dropdown */}
                            <Listbox
                              value={dailyTime} onChange={setDailyTime}
                            >
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button className="relative w-[140px] cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                      <span className="block truncate text-gray-700">{dailyTime?.time_slot ||"Select time.."}</span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      {notification_Data?.time_slots?.length > 0 && (
                                        <Listbox.Options className="absolute z-10 listing mt-1 max-h-36 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {notification_Data?.time_slots?.map((timeValue) => (
                                            <Listbox.Option
                                              key={timeValue?.id}
                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                                )
                                              }
                                              value={timeValue}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {timeValue?.time_slot}
                                                  </span>

                                                  {selected ? (
                                                    <span
                                                      className={classNames(
                                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                      )}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))}
                                        </Listbox.Options>
                                      )}
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                            {/* set days dropdown */}
                          </div>
            </div>
            <div className='flex gap-x-36 mt-8'>
              <div className='my-auto'>Weekly Time</div>
            <div className="flex mb-2 max-sm:gap-2 gap-6 my-auto">
                            {/* set hours time dropdown */}
                            <Listbox
                              value={weekTime} onChange={setWeekTime}
                            >
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button className="relative w-[140px] cursor-pointer rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                      <span className="block truncate text-gray-700">{weekTime?.time_slot ||"Select time.."}</span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      {notification_Data?.time_slots?.length > 0 && (
                                        <Listbox.Options className="absolute z-10 listing mt-1 max-h-36 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                          {notification_Data?.time_slots?.map((timeValue) => (
                                            <Listbox.Option
                                              key={timeValue?.id}
                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                  'relative cursor-default select-none py-2 pl-3 pr-9'
                                                )
                                              }
                                              value={timeValue}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {timeValue?.time_slot}
                                                  </span>

                                                  {selected ? (
                                                    <span
                                                      className={classNames(
                                                        active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                        'absolute inset-y-0 right-0 flex items-center pr-4'
                                                      )}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))}
                                        </Listbox.Options>
                                      )}
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                            {/* set days dropdown */}
                          </div>
            </div>

          </div>}

        </div>
        <Tooltip place='bottom' style={{ width: "300px"}} id="my-tooltip" />
        </>
    </>
    )
}



export default SettingNotification;